import { normalizePhone } from './normalize';
import { BatchLookupResult, EntitySelectionResult } from './types';

export function isSuffixMatch(phone1: string, phone2: string): boolean {
  if (!phone1 || !phone2) {
    return false;
  }

  const normalized1 = normalizePhone(phone1).replace(/\+/g, '');
  const normalized2 = normalizePhone(phone2).replace(/\+/g, '');

  if (!normalized1 || !normalized2) {
    return false;
  }

  return normalized1.endsWith(normalized2) || normalized2.endsWith(normalized1);
}

export function selectEntity(
  phone: string,
  batchResult: BatchLookupResult
): EntitySelectionResult | undefined {
  if (batchResult.notFoundArray?.includes(phone)) {
    return undefined;
  }

  const foundIndex = batchResult.foundArray?.indexOf(phone);
  if (foundIndex === undefined || foundIndex < 0) {
    return undefined;
  }

  const entity = batchResult.resultArray?.[foundIndex];
  if (!entity) {
    return undefined;
  }

  const displayName = entity.displayName || entity.name || phone;
  const entityId = entity.id || entity.entityId || '';
  const provider = entity.provider || 'unknown';

  if (Array.isArray(entity.phones)) {
    const normalizedInput = normalizePhone(phone);
    const hasSuffixMatch = entity.phones.some((entityPhone: any) => {
      const value = entityPhone?.value || entityPhone;
      return isSuffixMatch(normalizedInput, value);
    });

    if (!hasSuffixMatch) {
      return undefined;
    }
  }

  return { displayName, entityId, provider };
}
